<script lang="ts">
  interface Props {
    currentTab?: number;
    firstLabel?: string;
    secondLabel?: string;
    onChange?: (tab: number) => void;
  }

  let {
    currentTab = 1,
    firstLabel = "",
    secondLabel = "",
    onChange = () => {},
  }: Props = $props();

  const tabBaseClass =
    "flex w-1/2 h-[36px] items-center justify-center rounded-[8px] text-16 leading-none text-center text-[#8D8D8D] font-normal font-['PingFang_SC']";
  const tabActiveClass =
    "!bg-tab-capsule-bg-focus !text-[#2E4CE4] !font-semibold shadow-[0_2px_2px_rgba(0,0,0,0.05)]";
</script>

<div class="mb-[16px] w-full">
  <div class="flex items-center rounded-[8px] bg-tab-capsule-bg-normal p-[4px]">
    <button
      class={`${tabBaseClass} ${currentTab === 1 ? tabActiveClass : ""}`}
      onclick={() => onChange(1)}
    >
      {firstLabel}
    </button>
    <button
      class={`${tabBaseClass} ${currentTab === 2 ? tabActiveClass : ""}`}
      onclick={() => onChange(2)}
    >
      {secondLabel}
    </button>
  </div>
</div>
